module.exports = __webpack_public_path__ + "media/assets/images/smart_working/2-2-f6eee0a3ce7a221345307aca8dfff8fa.png";